import { render, staticRenderFns } from "./Trainee.vue?vue&type=template&id=794645c2&scoped=true&"
import script from "./Trainee.vue?vue&type=script&lang=js&"
export * from "./Trainee.vue?vue&type=script&lang=js&"
import style0 from "./Trainee.vue?vue&type=style&index=0&id=794645c2&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794645c2",
  null
  
)

export default component.exports